module.exports = __webpack_public_path__ + "media/success_notif_cargo.43d5a4f2.wav";